/**
 * Collection of strings to be shared across the component.
 * @enum {Object<string>}
 */
const CLASSES = {
  menu: 'dr-menu-holder--menu',
  languages: 'dr-menu-holder--languages',
  languagesButton: 'dr-language-selector',
  hamburguer: 'dr-nav__hamburguer',
  close: 'dr-menu-holder__close',
  menuOpened: 'dr-menu-holder--opened',
  buttonMenu: 'dr-menu-holder__button',
  dataTheme: 'data-theme'
}

/**
 * All numbers used in the component.
 * @enum {Object<number>}
 */
const NUMBERS = {
  minNavScroll: 10,
  maxNavScroll: 11
}

/**
 * @module Nav
 */
class Nav {
  /**
   * @param {HTMLElement} element - The HTMLElement this module is constructed upon
   */
  constructor(element) {
    this.element_ = element
    this.menu_ = this.element_.querySelector(`.${CLASSES.menu}`)
    this.hamburguer_ = this.element_.querySelector(`.${CLASSES.hamburguer}`)
    this.close_ = this.element_.querySelectorAll(`.${CLASSES.close}`)
    this.languages_ = this.element_.querySelector(`.${CLASSES.languages}`)
    this.buttonMenu_ = this.element_.querySelectorAll(`.${CLASSES.buttonMenu}`)
    this.dataTheme_ = document.querySelectorAll(`[${CLASSES.dataTheme}]`)
    this.languagesButton_ = this.element_.querySelectorAll(
      `.${CLASSES.languagesButton}`
    )
    this.init()
  }

  /**
   * Construct module.
   */
  init() {
    this.addEventListeners()
    this.scrollEvent()
  }

  /**
   * Add all events from the component.
   */
  addEventListeners() {
    this.hamburguer_.addEventListener('click', () => {
      this.menu_.classList.add(CLASSES.menuOpened)
    })

    this.buttonMenu_.forEach(buttonMenu =>
      buttonMenu.addEventListener('click', () => {
        this.menu_.classList.remove(CLASSES.menuOpened)
      })
    )

    this.close_.forEach(close =>
      close.addEventListener('click', () => {
        this.menu_.classList.remove(CLASSES.menuOpened)
        this.languages_.classList.remove(CLASSES.menuOpened)
      })
    )

    this.languagesButton_.forEach(button =>
      button.addEventListener('click', () => {
        this.languages_.classList.add(CLASSES.menuOpened)
      })
    )
    window.addEventListener('scroll', () => {
      this.scrollEvent()
    })
  }

  /**
   * Add scroll event from the component.
   */
  scrollEvent() {
    const { minNavScroll, maxNavScroll } = NUMBERS

    if (window.pageYOffset < minNavScroll) {
      this.element_.classList.remove(`dr-nav--black`)
      this.element_.classList.remove(`dr-nav--white`)
    } else if (window.pageYOffset > maxNavScroll) {
      this.element_.classList.add(`dr-nav--white`)
    }
    this.dataTheme_.forEach(section => {
      const dataThemeAttribute = section.getAttribute(CLASSES.dataTheme)
      const endPoint = section.getBoundingClientRect().y + section.offsetHeight
      const startingPoint =
        section.getBoundingClientRect().y - this.element_.offsetHeight
      if (startingPoint < 0 && endPoint > 0) {
        this.element_.classList.remove(`dr-nav--black`)
        this.element_.classList.remove(`dr-nav--white`)
        this.element_.classList.add(`dr-nav--${dataThemeAttribute}`)
      }
    })
  }
}

// Exports
export default Nav
